f-popover {
  .m-popover {
    &__content {
      width: 350px;
    }

    .a-box {
      z-index: 9;
      display: none;
      height: auto;
    }

    &-container {
      text-align: center;
      display: flex;
      position: relative;

      .-right {
        display: block;

        &-bottom {
          top: -10rem;
          position: absolute !important;
          left: -23rem;

          .a-box {
            &::before {
              top: 170px !important;
              bottom: 0 !important;
            }

            &::after {
              top: 170px !important;
              bottom: 0 !important;
            }
          }
        }
      }
    }

    &__head f-button {
      position: absolute;
      top: 0;
      right: 0;
    }

    .-show {
      display: block;
    }
  }
}
